module.exports = __webpack_public_path__ + "img/img38.ef251df8.svg";